import { Col, Nav, Row } from 'react-bootstrap';

type NavbarLabelProps = {
  label: string;
};

const NavbarLabel = ({ label }: NavbarLabelProps) => (
  <Nav.Item as="li">
    <Row className="mt-3 mb-2 navbar-vertical-label-wrapper">
      <Col
        xs="auto"
        className="navbar-vertical-label text-900 navbar-vertical-label"
      >
        {label}
      </Col>
      <Col className="ps-0">
        <hr className="mb-0 navbar-vertical-divider" />
      </Col>
    </Row>
  </Nav.Item>
);

export default NavbarLabel;
